
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SortingItemsGrid extends Serenity.EntityGrid<SortingItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.SortingItems'; }
        protected getDialogType() { return SortingItemsDialog; }
        protected getIdProperty() { return SortingItemsRow.idProperty; }
        protected getInsertPermission() { return SortingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SortingItemsRow.localTextPrefix; }
        protected getService() { return SortingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}